import React from 'react';
import '../style/formGroupTextInput.css'
import ValidationMessage from "./validationMessage";
import FormGroupPlainText from "./formGroupPlainText";

const FormGroupTextInput = (props) => {
    const {isPlain, onLabelClick, labelAsALink,leftWrapper} = props;
    let pattern = props.pattern;
    let title = props.title;
    if(!pattern && props.Required){
        pattern = '.*\\S.*' ;
        title = 'Whitespaces are not allowed.'
    }

    if(isPlain){
        return (
            <FormGroupPlainText
                labelAsALink={labelAsALink}
                onLabelClick={onLabelClick}
                RightWrapper={props.RightWrapper}
                rightData={props.rightData}
                LeftWrapper="col-sm-3"
                InputWrapper={props.InputWrapper}
                Label={props.Label}
                Text={props.Value}
            />
        )
    }

    return (
        <div className="form-group">
            <div className={leftWrapper ? leftWrapper:"col-sm-3"}>
                <label className={"control-label.text-left formGroup-textInput-label" +
                (props.Required?' inputRequired':'')
                }>
                    {props.Label}
                    </label>
            </div>
            <div className={props.InputWrapper}>
                {
                    props.Type === 'file'?
                        <input type={props.Type} disabled={props.Disabled} required={props.Required} className="" placeholder={props.Placeholder} name={props.Name} value={props.Value} onChange={(evt) => props.HandleInputChange(evt.target.name, evt.target.value)}/>
                        :
                        <input
                            autoComplete={props.autoComplete}
                            type={props.Type}
                            pattern={pattern}
                            title={title}
                            max={props.max}
                            min={props.min}
                            step={props.step}
                            disabled={props.Disabled}
                            required={props.Required}
                            className="form-control formGroup-textInput-input"
                            placeholder={props.Placeholder}
                            name={props.Name}
                            value={props.Value}
                            onChange={(evt) => props.HandleInputChange(evt.target.name, evt.target.value)}/>
                }
                {props.ErrorExists?
                    <ValidationMessage Label={props.ErrorMessage}/>
                    :
                    null
                }
            </div>
            <div className={props.RightWrapper}>{props.rightData?props.rightData:null}</div>
        </div>
    )
};

export default FormGroupTextInput;